angular.module('com.vmware.platform.ui').directive('objectNavigator', [function () {
   return {
      restrict: 'E',
      templateUrl: 'resources/ui/views/objectnavigator/ObjectNavigator.html',
      controller: 'ObjectNavigatorController'
   };
}]);
